import React from 'react';

import { LoyaltyBannerDesktop } from './LoyaltyBanner.Desktop';
import { LoyaltyBannerMobile } from './LoyaltyBanner.Mobile';

interface LoyaltyBannerProps {
  credit: string;
  memberSince?: string;
}

export const LoyaltyBanner = ({ credit, memberSince }: LoyaltyBannerProps) => {
  return (
    <>
      {/* Mobile View - Below tablet breakpoint (768px) */}
      <div className="tablet:hidden">
        <LoyaltyBannerMobile credit={credit} />
      </div>

      {/* Desktop View - Above tablet breakpoint */}
      <div className="hidden tablet:block">
        <LoyaltyBannerDesktop credit={credit} memberSince={memberSince} />
      </div>
    </>
  );
};
